import { render } from "./OperateOrderDetail.vue?vue&type=template&id=35365c59"
import script from "./OperateOrderDetail.vue?vue&type=script&lang=js"
export * from "./OperateOrderDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__